import { render, staticRenderFns } from "./main.vue?vue&type=template&id=125d21b2"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125d21b2')) {
      api.createRecord('125d21b2', component.options)
    } else {
      api.reload('125d21b2', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=125d21b2", function () {
      api.rerender('125d21b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/partner/view/main.vue"
export default component.exports